module.exports = __webpack_public_path__ + "img/print-files-mobile.fc7fef8.svg";